import { Box, useMediaQuery, useTheme } from "@mui/system";
import Grid from "@mui/material/Grid";
import { Outlet } from "react-router-dom";
import SideNavBarMenu from "./../ui/SideNavBarMenu";
import DialogStatusPopup from "../common/DialogStatusPopup";
import RightLayoutOutlet from "../common/RightLayoutOutlet";

const DashboardLayout = () => {
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ display: "flex", background: "#F8F7FA" }}>
      <SideNavBarMenu />
      <Box
        component="main"
        className="dashboard-Layout"
        sx={{ paddingTop: "35px" }}
      >
        <Box className="dashboard-main-section">
          <Grid container spacing={2} sm>
            <Grid item xs={12} sm={9} md={9} lg={9} sx={{ minWidth: 0 }}>
              <Outlet />
            </Grid>
            <Grid item xs={12} sm={3} md={3} lg={3} sx={{ minWidth: 0 }}>
              {!isXsOrSm && <RightLayoutOutlet />}
            </Grid>
          </Grid>
        </Box>
        <Box component="footer" className="footer">
          Copyright © {new Date().getFullYear()} Avanse Financial Services Ltd.
          All Rights Reserved .
        </Box>
      </Box>
      <DialogStatusPopup />
    </Box>
  );
};

export default DashboardLayout;
